import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)); }, []);

  return (
    <div className="font-body">
      <div className="bg-[#08341f] py-16 text-center text-white">
        <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Blog & Guides</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-bold mt-3">Insights, Guides & Investment Tips</h1>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {blogs.map((b, i) => (
          <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} style={{animationDelay:`${i*80}ms`}} className="animate-fade-up group rounded-xl overflow-hidden border border-gray-100 hover:shadow-[0_16px_48px_rgba(11,93,59,0.12)] transition-shadow">
            <div className="h-52 overflow-hidden"><img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/></div>
            <div className="p-6">
              <span className="text-xs uppercase tracking-wide text-[#D4AF37] font-semibold">{b.category}</span>
              <h3 className="font-heading font-semibold text-lg text-gray-900 mt-2 group-hover:text-[#0B5D3B] transition-colors">{b.title}</h3>
              <p className="text-sm text-gray-500 mt-2 line-clamp-2">{b.excerpt}</p>
              <span className="flex items-center gap-1 text-sm font-semibold text-[#0B5D3B] mt-4">Read More <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform"/></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
